import { render, staticRenderFns } from "./ContDeliveryType.vue?vue&type=template&id=622c18fd&scoped=true&"
import script from "./ContDeliveryType.vue?vue&type=script&lang=js&"
export * from "./ContDeliveryType.vue?vue&type=script&lang=js&"
import style0 from "./ContDeliveryType.vue?vue&type=style&index=0&id=622c18fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c18fd",
  null
  
)

export default component.exports